import { Linkedin } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 bg-[#1A1A1A]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="font-['Cormorant_Garamond'] text-2xl font-semibold text-[#F9F6F0] hover:text-[#C5A059] transition-colors tracking-tight"
            data-testid="footer-logo"
          >
            The Creative Seen
          </a>

          {/* Social Links */}
          <div className="flex items-center gap-6">
            <a
              href="https://www.linkedin.com/in/manisha-majithia-b34260112/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#F9F6F0] hover:text-[#C5A059] transition-colors"
              aria-label="LinkedIn"
              data-testid="linkedin-link"
            >
              <Linkedin size={22} strokeWidth={1.5} />
            </a>
          </div>

          {/* Copyright */}
          <p className="font-['Manrope'] text-sm text-[#4A4542]">
            © {currentYear} The Creative Seen. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
